if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaContent = this.querySelector('.product-media-modal__content');
        this.prevButton = this.querySelector('[data-media-modal-prev]');
        this.nextButton = this.querySelector('[data-media-modal-next]');
        this.scrollRaf = null;

        this.prevButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));

        [this.prevButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
          button.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(1);
          }
        });

        this.mediaContent?.addEventListener(
          'scroll',
          () => {
            if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
            this.scrollRaf = requestAnimationFrame(() => {
              this.scrollRaf = null;
              this.syncActiveByScroll();
            });
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      getCurrentIndex() {
        const items = this.getMediaItems();
        if (!items.length) return { index: 0, items };

        const activeIndex = items.findIndex((item) => item.classList.contains('active'));
        if (activeIndex >= 0) return { index: activeIndex, items };

        const width = this.mediaContent?.clientWidth || 1;
        const scrollIndex = Math.round((this.mediaContent?.scrollLeft || 0) / width);
        const index = Math.max(0, Math.min(items.length - 1, scrollIndex));
        return { index, items };
      }

      setActiveMedia(activeMedia) {
        const items = this.getMediaItems();
        items.forEach((item) => item.classList.toggle('active', item === activeMedia));

        if (activeMedia?.nodeName === 'DEFERRED-MEDIA' && typeof activeMedia.loadContent === 'function') {
          activeMedia.loadContent(false);
        }
      }

      syncActiveByScroll() {
        const { index, items } = this.getCurrentIndex();
        const media = items[index];
        if (!media) return;
        this.setActiveMedia(media);
        this.updateNav(index, items.length);
      }

      updateNav(index, total) {
        const disabled = total <= 1;
        if (this.prevButton) this.prevButton.disabled = disabled;
        if (this.nextButton) this.nextButton.disabled = disabled;
      }

      goToIndex(index, behavior = 'smooth') {
        const items = this.getMediaItems();
        if (!items.length) return;

        const safeIndex = Math.max(0, Math.min(items.length - 1, index));
        const target = items[safeIndex];
        this.setActiveMedia(target);
        this.updateNav(safeIndex, items.length);

        const width = this.mediaContent?.clientWidth || 1;
        const targetLeft = safeIndex * width;
        this.mediaContent?.scrollTo({ left: targetLeft, behavior });
      }

      step(direction) {
        const { index, items } = this.getCurrentIndex();
        const total = items.length;
        if (!total) return;

        const nextIndex = (index + direction + total) % total;
        this.goToIndex(nextIndex, 'smooth');
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.setActiveMedia(activeMedia);
        activeMedia.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });

        const { index, items } = this.getCurrentIndex();
        this.updateNav(index, items.length);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
